import React from "react";

const ShowProjectImages = (props) => <div>Images</div>;

export default ShowProjectImages;
